import {
  eolsBaseApi,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';
import {
  EvolveTokenDto,
  ShadowHealthCourseDto
} from './evolve-user-management-client.dtos';

export const getShadowHealthRelatedCourses = (userId: string): Promise<ShadowHealthCourseDto[]> => {
  // https://elsevier.atlassian.net/browse/EVL-3671
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(`/evolveUser/${userId}/resourceListByProductType/shadow_health`);
  });
};

export const getEvolveToken = (): Promise<EvolveTokenDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post('/evolveUser/sso');
  });
};
